/**
 * English translations (Base Language)
 */
const en = {
  // === Common UI ===
  ok: 'OK',
  cancel: 'Cancel',
  close: 'Close',
  confirm: 'Confirm',
  language: 'Language',

  // === Title / Start ===
  game_title: 'Sword Enhance',
  tap_to_start: 'Tap to Start',
  title_load_failed: 'Title image load failed:',
  game_started: 'Sword Enhance started!',

  // === Main HUD ===
  level_label: 'Lv.{n}',
  gold_suffix: 'G',
  rate_suffix: '%',
  rate_clear: 'All Clear!',
  rate_display: '{rate}%',
  rate_display_boosted: '{rate}% UP',
  gold_display: '{amount} G',
  gold_display_free: '0 G (Free!)',

  // === Main Buttons ===
  btn_enhance: 'Enhance',
  btn_enhance_ready: 'Enhance',
  btn_enhance_complete: 'Complete',
  btn_free_enhance: 'Free Enhance',
  btn_exhausted: 'Used Up',
  btn_boost: 'Rate\nUP',
  btn_applying: 'Active\n!',
  btn_protection_active: 'Protection Active',
  btn_protection_use: 'Use Scroll',
  btn_sell: 'Sell',
  btn_sell_amount: '{amount}G',
  btn_shop: 'Shop',
  cost_max: 'MAX',
  cost_free: '0 G (Free!)',

  // === Settings Menu ===
  tab_settings: 'Settings',
  tab_inventory: 'Inventory',
  bgm_on: 'BGM ON',
  bgm_off: 'BGM OFF',
  sfx_on: 'SFX ON',
  sfx_off: 'SFX OFF',
  inventory_title: 'Stored Weapons',
  inventory_empty: 'No stored weapons',
  equip: 'Equip',
  equip_msg: '{name} equipped!',
  reset_confirm_title: 'Really reset?',
  reset_confirm_desc: 'All progress will be deleted',
  reset: 'Reset',
  reset_start_over: 'Start Over',
  menu_close: 'Close',

  // === Inventory scrolls counts ===
  inv_scrolls_title: 'Protection Scrolls',
  inv_scrolls_line1: 'Basic: {c0}  |  Mid: {c1}',
  inv_scrolls_line2: 'High: {c2}  |  Ultra: {c3}',
  inv_weapon_entry: '{name} (Lv.{level})',

  // === Ad Gold Popup (Free Enhance) ===
  ad_gold_title: 'Watch Ad for Free Enhance',
  ad_gold_desc: 'Next enhance costs 0 gold',
  ad_gold_note: '(Scrolls and Rate UP still apply)',
  ad_gold_confirm: 'Watch Ad',
  ad_gold_free_next: 'Next enhance free!',
  ad_gold_exhausted: 'Used up!',
  ad_gold_remaining: 'Remaining: {current}/3',

  // === Boost Popup ===
  boost_popup_title: 'Watch Ad',
  boost_confirm: 'Watch Ad to Apply',
  boost_close: 'Close',
  boost_applied: 'Rate UP applied!',
  boost_already_applied: 'Already active!',
  boost_exhausted: 'Used up!',
  boost_remaining: 'Remaining uses: {current}/3',
  boost_popup_desc: 'Now {rate}% -> x{mult}',
  boost_rate_display: '{rate}%',
  boost_mult_2x: '2x',
  boost_mult_1_5x: '1.5x',
  boost_mult_1_3x: '1.3x',

  // === Protection Popup ===
  protection_popup_title: 'Use Protection Scroll',
  protection_use: 'Use',
  protection_cancel: 'Cancel',
  protection_popup_info:
    'Current Level: Lv.{level}\nRequired: {name} x1\nYou have: {count}',
  protection_activated: '{name} activated!',
  protection_returned: '{name} returned',
  protection_protected: 'Protected by Scroll!',

  // === Enhance Result Messages ===
  msg_max_level: 'Already at max level!',
  msg_gold_short: 'Not enough gold!',
  msg_success_boost: 'Boost Enhance Success!',
  msg_success: 'Enhance Success!',
  msg_destroyed: 'DESTROYED!',

  // === Shop ===
  shop_title: 'Shop',
  tab_protection: 'Protection',
  tab_weapons: 'Buy Weapons',
  weapon_shop_title: 'Buy Weapons',
  item_free: 'Free',
  close_shop: 'Close',
  buy_complete_title: 'Purchase Complete!',
  buy_complete_desc:
    'Your purchased items are available in\nSettings (top) -> Inventory!',
  buy_complete_ok: 'OK',
  scroll_shop_label: '{name} (Lv.{min}-{max})',
  scroll_purchased: '{name} obtained!',
  weapon_moved_to_inventory: '{name} -> Inventory',
  price_display: '{amount}G',
  sell_received: '+{amount}G!',

  // === Ad Restore (Destruction Popup) ===
  destroy_title: 'Weapon Destroyed',
  destroy_ad_restore: 'Watch Ad to Restore',
  destroy_restore_ad: 'Watch Ad to Restore ({current}/{max})',
  destroy_give_up: 'Start Over',
  destroy_restore_count: 'Restore chances: {current}/{max}',
  destroy_restored: 'Lv.{level} weapon restored!',
  ad_watch_fail: 'Ad failed to play',
  weapon_restored: '{name} restored!',

  // === Completion ===
  completion_title: 'You completed the ultimate sword!',
  completion_all_done: 'All Enhancements Complete!',
  congrats_text: 'Congratulations!',
  register_name: 'Register Name',
  prompt_register_name: 'Enter your name for the Hall of Fame:',
  no_completion: 'No completers yet',
  be_first: 'Be the first to finish!',
  completion_close: 'Close',
  leaderboard_title: 'Hall of Fame',
  leaderboard_entry: '#{rank} - {name}',
  completion_rank_msg: 'You are completer #{rank}!',
  completion_total_msg: '{total} players have completed so far',

  // === Errors / Logs ===
  weapon_image_load_failed: 'Weapon image load failed:',

  // === Weapons (0 = bare hands, 1-34 = enhancement levels) ===
  weapon_0: 'Bare Hands',
  weapon_1: 'Plain Dagger',
  weapon_2: 'Iron Sword',
  weapon_3: 'Silver Sword',
  weapon_4: 'Snowboard Sword',
  weapon_5: 'Wave Sword',
  weapon_6: 'Magical Girl Sword',
  weapon_7: 'Bear Sword',
  weapon_8: 'Burning Skull Sword',
  weapon_9: 'Lightning Sword',
  weapon_10: 'Moonlight Dagger',
  weapon_11: 'Dragon Sword',
  weapon_12: 'Muscle Sword',
  weapon_13: 'King Diamond Sword',
  weapon_14: 'Azure Dragon Crescent Blade',
  weapon_15: 'Ancient Sword',
  weapon_16: "Pirate King's Dual Swords",
  weapon_17: 'Dubai Chewy Sword',
  weapon_18: 'Seven-Seven Blade',
  weapon_19: 'Magical Girl Staff Sword',
  weapon_20: 'Buzzing Sword',
  weapon_21: 'Palette Sword',
  weapon_22: 'Nature Sword',
  weapon_23: 'Cyborg Sword',
  weapon_24: 'Blackhole Sword',
  weapon_25: 'Golden Bird Sword',
  weapon_26: 'Crystal Power Sword',
  weapon_27: 'Dark Dragon Sword',
  weapon_28: 'Pincer Sword',
  weapon_29: 'AI Sword',
  weapon_30: 'Chainsaw Sword',
  weapon_31: 'Shooting Star Sword',
  weapon_32: 'Dark Dark Sword',
  weapon_33: 'Galaxy Sword',
  weapon_34: 'Super Expensive Diamond Sword',

  // === Protection Scrolls ===
  scroll_basic: 'Basic Protection Scroll',
  scroll_mid: 'Mid Protection Scroll',
  scroll_hi: 'High Protection Scroll',
  scroll_ultra: 'Ultra Protection Scroll',
  scroll_label_basic: 'Basic',
  scroll_label_mid: 'Mid',
  scroll_label_hi: 'High',
  scroll_label_ultra: 'Ultra',

  // === Materials (Sprint 1) ===
  mat_iron_dust: 'Iron Dust',
  mat_refining_core: 'Refining Core',
  mat_lava_essence: 'Lava Essence',
  mat_abyss_crystal: 'Abyss Crystal',

  mat_drop_notice: '+{amount} {name}',
  mat_drop_title: 'Material Obtained!',
  mat_double_ad: 'Watch Ad x2',
  mat_doubled: 'x2 Applied!',
  mat_panel_title: 'Materials',

  // === Keep / Weapon Inventory (Sprint 1) ===
  keep_btn: 'Keep',
  keep_full: 'Storage Full!',
  keep_lv1_blocked: 'Lv.1 weapons cannot be stored',
  keep_success: '{name} stored!',
  keep_retrieve: 'Equip',
  keep_sell: 'Sell',
  keep_slot_expand: 'Expand Slot',
  keep_slot_cost: '{amount}G',
  keep_slot_max: 'MAX',
  keep_slot_count: 'Slots: {used}/{total}',
  keep_panel_title: 'Stored Weapons',
  keep_empty: 'No stored weapons',
  keep_weapon_entry: 'Lv.{level} {name}',
  keep_sell_received: '+{amount}G',
  keep_no_slot: 'Buy more slots!',

  // === Forge / Furnace (Sprint 2) ===
  tab_forge: 'Forge',
  forge_title: 'Forge',
  forge_tab_weapon: 'Weapons',
  forge_tab_scroll: 'Scrolls',
  forge_tab_upgrade: 'Upgrade Mats',
  forge_craft_btn: 'Craft',
  forge_craft_success: '{name} crafted!',
  forge_not_enough_mat: 'Not enough materials',
  forge_weapon_to_equip: 'Equip now?',
  forge_weapon_to_keep: 'Keep',
  forge_weapon_equip: 'Equip',
  forge_keep_full_equip: 'Storage full — equipping directly.',
  forge_cost_label: 'Cost:',
  forge_result_label: 'Result:',

  // Recipe names
  forge_recipe_weapon_lv5: 'Craft Lv.5 Weapon',
  forge_recipe_weapon_lv10: 'Craft Lv.10 Weapon',
  forge_recipe_weapon_lv15: 'Craft Lv.15 Weapon',
  forge_recipe_weapon_lv21: 'Craft Lv.21 Weapon (Pity)',
  forge_recipe_weapon_lv21_desc: 'Get a Lv.21 weapon instantly — no enhancing, no fails!',
  forge_recipe_scroll_basic: 'Craft Basic Protection Scroll',
  forge_recipe_scroll_mid: 'Craft Mid Protection Scroll',
  forge_recipe_scroll_hi: 'Craft High Protection Scroll',
  forge_recipe_scroll_ultra: 'Craft Ultra Protection Scroll',
  forge_recipe_upgrade_1: 'Iron Dust → Refining Core',
  forge_recipe_upgrade_2: 'Refining Core → Lava Essence',
  forge_recipe_upgrade_3: 'Lava Essence → Abyss Crystal',

  // === Protection Scroll Shop (descriptions + buy button) ===
  scroll_effect_basic: 'Prevents destruction on fail (Lv.1-9)',
  scroll_effect_mid: 'Prevents destruction on fail (Lv.10-19)',
  scroll_effect_hi: 'Prevents destruction on fail (Lv.20-24)',
  scroll_effect_ultra: 'Prevents destruction on fail (Lv.25-34)',
  scroll_buy_btn: 'Buy',

  // === Stored Weapons Panel (card layout) ===
  keep_card_equip: 'Equip',
  keep_card_sell: 'Sell',
  keep_slot_empty: 'Empty',

  // === Sacrifice System (Sprint 3) ===
  sacrifice_btn: 'Offer Weapon',
  sacrifice_panel_title: 'Sacrifice Weapons',
  sacrifice_panel_desc: 'Offering Lv.{level} weapons raises success rate by +{tierPct}% each',
  sacrifice_empty: 'No Lv.{level} weapons in storage',
  sacrifice_bonus_label: 'Bonus: +{pct}%',
  sacrifice_cap_label: '({count}/{cap})',
  sacrifice_offer_btn: 'Offer',
  sacrifice_ad_slots: 'Watch Ad: +{pct}% success rate',
  sacrifice_ad_exhausted: 'Ad limit reached',
  sacrifice_ad_granted: '+3 sacrifices added!',
  sacrifice_added: 'Sacrifice accepted! +{tierPct}% bonus',
  sacrifice_cap_reached: 'Sacrifice limit reached',
  sacrifice_reset: 'Sacrifice bonus reset',

  // === Infinity Mode (Sprint 3) ===
  infinity_btn: 'Infinity',
  infinity_active: 'FREE {sec}s',
  infinity_popup_title: 'Infinity Mode',
  infinity_popup_desc: 'Enhance all you want for 10 seconds — no gold!\nSame success rate as always, so it can still break!',
  infinity_popup_confirm: 'Watch Ad',
  infinity_popup_close: 'Close',
  infinity_cooldown: 'Ready in {sec}s',
  infinity_daily_exhausted: 'Daily limit reached',
  infinity_started: 'Infinity Mode ON! Free for 10s',
  infinity_ended: 'Infinity Mode ended',

  // === Buff Items (Sprint 3) ===
  buff_item_luck_charm: 'Luck Charm',
  buff_item_guarantee: 'Guarantee Ticket',
  buff_item_destroy_guard: 'Break Guard',
  buff_item_use: 'Use',
  buff_item_active: 'Active',
  buff_item_empty: '0',
  buff_luck_charm_activated: 'Luck Charm active! +5% next enhance',
  buff_guarantee_activated: 'Guarantee Ticket active! 100% next enhance',
  buff_destroy_guard_activated: 'Break Guard active! Next fail = no break',
  buff_luck_charm_consumed: 'Luck Charm consumed',
  buff_guarantee_consumed: 'Guarantee Ticket consumed',
  buff_destroy_guard_consumed: 'Break Guard used — weapon saved!',
  buff_item_already_active: 'Already active!',
  buff_item_none: 'No {name}',
  // === Buff Item Info Popup ===
  buff_popup_count: 'You have: {count}',
  buff_popup_use_btn: 'Use Now',
  buff_popup_no_stock: 'You have none. Craft it in the Forge.',
  buff_popup_luck_charm_effect: '+5% success rate for the next enhance',
  buff_popup_guarantee_effect: 'Next enhance is guaranteed 100% success',
  buff_popup_destroy_guard_effect: 'If the next enhance fails, your weapon will NOT break',

  // === Forge Item Recipes (Sprint 3) ===
  forge_recipe_item_luck_charm: 'Craft Luck Charm',
  forge_recipe_item_luck_charm_desc: '+5% success rate for next enhance',
  forge_recipe_item_guarantee: 'Craft Guarantee Ticket',
  forge_recipe_item_guarantee_desc: 'Next enhance is 100% success',
  forge_recipe_item_destroy_guard: 'Craft Break Guard',
  forge_recipe_item_destroy_guard_desc: 'Weapon will NOT break on next fail',
  forge_tab_item: 'Items',
} as const;

export default en;
export type TranslationKey = keyof typeof en;
export type Translations = Record<TranslationKey, string>;
